import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import * as PropTypes from 'prop-types';
import UpdateEpikBox from '../UpdateEpikBox';
import './index.css';
import EditDevice from '../../../Res/Icon/pen.png';
import { isAdminRole } from '../../../lib/utils';
import { ReactComponent as Favorite } from '../../../Res/svg/favoriteFill.svg';
import { ReactComponent as FavoriteEmpty } from '../../../Res/svg/favoriteEmpty.svg';
import FavoriteButton from './FavoriteButton';
import TooltipCustom from '../EpikBoxDetails/TooltipCustom';
import ConfirmationModal from '../../ConfirmationModal';

class UpdateEpikBoxModal extends Component {
  constructor(props) {
    super(props);
    const { box } = this.props;
    this.state = {
      _id: box._id,
      address: box.address || {},
      displayName: box.displayName,
      customerProvidedIp: box.customerProvidedIp || '',
      lteIp: box.lteIp || '',
      lteIp2: box.lteIp2 || '',
      wgPublicKey: box.wgPublicKey || '',
      serialNumber: box.serialNumber,
      model: box.model,
      assignedTo: box.assignedTo,
      locRef: box.locRef || {},
      numModems: box.numModems,
      numberOfModems: box.numberOfModems,
      imei: box.imei || [],
      imsi: box.imsi || [],
      modemPhone: box.modemPhone || [],
      notifyEmails: box.notifyEmails,
      emergencyEmails: box.emergencyEmails || [],
      notifyNumbers: box.notifyNumbers,
      emergencyNumbers: box.emergencyNumbers || [],
      editStatus: true,
      apn: box.apn || [],
      vpnAddress: box.vpnAddress || '',
      shipment: box.shipment || '',
      alertCompanyMails: box.alertCompanyMails || false,
      modems: box.modems || [],
      secondaryNotification: box.secondaryNotification || false,
      secondaryNotifyEmails: box.secondaryNotifyEmails || [],
      secondaryNotifyNumbers: box.secondaryNotifyNumbers || [],
      notesAction: '',
      favoriteStatus: false,
      customerProvideSIM1: box?.customerProvideSIM1,
      customerProvideSIM2: box?.customerProvideSIM2,
      dcUpdatePopup: {
        show: false,
        value: {}
      },
      batteryReplacedOn: box?.batteryReplacedOn,
      revision: box?.revision || '',
    };
    this.onFormDataChange = this.onFormDataChange.bind(this);
  }
  unLockBoxButton = async () => {
    const element = document.getElementById('test-lock-icon');
    if (element) {
      // Simulate a click event
      element.click();
    } else {
      console.error('Element with id "test-lock-icon" not found.');
    }
  };
  onFormDataChange = partialFormData => {
    if (partialFormData.numModems === 0) {
      this.setState(
        {
          imei: [],
          imsi: [],
          modemPhone: [],
        },
        () => {
          this.setState({
            ...partialFormData,
          });
        },
      );
    } else {
      this.setState(
        {
          ...partialFormData,
        },
        () => { },
      );
    }
  };

  onConfirmPress = () => {
    const { onConfirm } = this.props;
    const { modems } = this.state;
    const hasSims = Object.hasOwn(modems[0], 'sims');
    if (hasSims && !modems[0]?.sims[1] && modems.length < 2) {
      this.setState(
        {
          lteIp2: '',
        },
        () => {
          onConfirm({ ...this.state });
        },
      );
    } else {
      onConfirm({ ...this.state });
    }
  };

  render() {
    const { isOpen, onCancel, enableBoxEdit, firmSelectedType, user, getBoxData } = this.props;
    const { editStatus } = this.state;
    const editButton = isAdminRole(user.role) ? <> </> : (
      <div className='d-flex'>
        <FavoriteButton boxId={this.state._id} />
        <Button
          aria-label="Edit Edge Device"
          disabled={!enableBoxEdit || user.readOnly}
          className="edit-btns"
          color="default"
          onClick={() => {
            const divElement = document.getElementById('test-time-remaining');
            if (divElement) {
            const isHidden = divElement.getAttribute('hidden') !== null;
           
              if (isHidden) {
                this.setState({ dcUpdatePopup: { show: true } });
              } else {
                this.setState({ editStatus: false });
              }
            } else {
              this.setState({ editStatus: false });
            }
          }}
          id="edit-box"
        >
          <img style={{ width: '35px' }} src={EditDevice} alt="Edit Edge Device"  aria-hidden="true" role="presentation"/>
        </Button>
        <TooltipCustom
          tipId="edit-box"
          displayData="Edit Edge Device"
          placement="top"
        />
      </div>
    );

    return (
      <div>
      <Modal isOpen={isOpen} toggle={onCancel} className="create-box-modal">
        <ModalHeader close={editButton}>Edge Device Details</ModalHeader>
        <ModalBody>
          <UpdateEpikBox
            firmSelectedType={firmSelectedType}
            boxDetails={this.state}
            onFormDataChange={this.onFormDataChange}
            getBoxData={getBoxData}
            boxData={this.props?.box}
          />
        </ModalBody>

        <ModalFooter>
          <Button outline color="secondary" onClick={onCancel}>
            Close
          </Button>
          {!editStatus && (
            <Button
              color="primary"
              onClick={() => {
                this.onConfirmPress();
              }}
              toggle={onCancel}
            >
              Save
            </Button>
          )}
        </ModalFooter>
      </Modal>
      <ConfirmationModal
          bodyText={'You are attempting to make changes to a device that is not currently locked for editing. To prevent conflicting changes, please lock the device before proceeding.'}
          headerText={'Device Lock Required'}
          confirmBtnText={'Lock & Edit'} 
          close={'No'} 
          isOpen={this.state.dcUpdatePopup.show}
          onCancel={() => {
            this.setState({ dcUpdatePopup: { show: false, value: {} } });
          }}
          onConfirm={() => {
            this.unLockBoxButton();
            this.setState({ dcUpdatePopup: { show: false, value: {} } });
          }}
        />
      </div>
    );
  }
}

UpdateEpikBoxModal.propTypes = {
  onConfirm: PropTypes.any,
  onCancel: PropTypes.any,
  isOpen: PropTypes.any,
};

export default UpdateEpikBoxModal;
